import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getIsChatEnabled } from "~/store/selectors/selector.configOptions";

export const RequireChatAvailable = ({ children, redirectTo }) => {
  const isChatAvailable = useSelector(getIsChatEnabled);

  return isChatAvailable ? children : <Navigate to={redirectTo} />;
};

RequireChatAvailable.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireChatAvailable.defaultProps = {
  redirectTo: "/not-found",
};
